import { cn } from "@/lib/utils";

const styleMap = {
  approved: "badge-approved",
  in_progress: "badge-progress",
  review: "badge-review",
  rejected: "badge-rejected",
  neutral: "badge-neutral",
};

const STATUS_TO_TONE = {
  "Lead Created": "neutral",
  "Quick Eligibility Started": "neutral",
  "Eligibility Passed": "in_progress",
  "Eligibility Failed": "rejected",
  "Full Application Pending": "in_progress",
  "Documents Pending": "review",
  "CarDr Report Pending": "review",
  "Valuation Pending": "in_progress",
  "Underwriting Pending": "in_progress",
  "Additional Documents Required": "review",
  "Approved": "approved",
  "Approved with Conditions": "approved",
  "Rejected": "rejected",
  "Sanction Letter Generated": "approved",
  "Agreement Pending": "in_progress",
  "eNACH Pending": "in_progress",
  "Disbursement Pending": "in_progress",
  "Disbursed": "approved",
  "Active Loan": "approved",
  "Closed": "neutral",
};

export default function StatusBadge({ status, className }) {
  const tone = STATUS_TO_TONE[status] || "neutral";
  return (
    <span
      data-testid={`status-badge-${(status || "").toLowerCase().replace(/\s+/g, "-")}`}
      className={cn("inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border", styleMap[tone], className)}
    >
      {status || "—"}
    </span>
  );
}
